<template>
    <div class="single-table previous-results">
      <div class="table-head">
        <h4>{{$t('vdog_previous_result')}}</h4>
      </div>
      <div class="table-body">
        <!-- First row -->
        <div class="row" v-for="(result, index) in computedMatches()" :key="index">
          <div class="single-result">
            <span class="round">{{$t('vdog_round')}} {{result.RoundNo % 1000}}</span>
              <div class="a-vg-c--ont" :class="extractClassForDogPosition(result.FirstPlace - 1)">
                <span>{{(result.FirstPlace)}}</span>
                <img :src="awardImage(1)" :alt="awardAltTag(1)" />
              </div>
            <span class="result-title">{{$t('vdog_winner')}}</span>
          </div>
          <div class="single-result">
            <div class="a-vg-c--ont" :class="extractClassForDogPosition(result.SecondPlace - 1)">
              <span>{{(result.SecondPlace)}}</span>
              <img :src="awardImage(2)" :alt="awardAltTag(2)" />
            </div>
            <span class="result-title">{{$t('vdog_second')}}</span>
          </div>
          <div class="single-result">
            <div class="a-vg-c--ont" :class="extractClassForDogPosition(result.ThirdPlace - 1)">
              <span>{{(result.ThirdPlace)}}</span>
              <img :src="awardImage(3)" :alt="awardAltTag(3)" />
          </div>
        <span class="result-title">{{$t('vdog_third')}}</span>
      </div>
    </div>
  </div>
</div>
</template>

<script>
import NumberFormat from '@/mixins/NumberFormat'
import VDogHelper from '@/mixins/VDogHelper'
import LanguageHelper from '@/mixins/LanguageHelper'

export default {
  mixins: [NumberFormat, VDogHelper, LanguageHelper],
  props: {
    matchResults: {
      type: Array,
      default: function () {
        return []
      }
    },
    areLastResultsVisible: {
      type: Number,
      required: true,
      default: 0
    }
  },
  methods: {
    format: function (value) {
      return this.formatNumber(value, this.getLanguageCodeForNumbers())
    },
    computedMatches: function (value) {
      if (this.areLastResultsVisible) {
        return this.matchResults.slice(1, this.matchResults.length)
      }
      return this.matchResults.slice(0, this.matchResults.length - 1)
    }
  }
}
</script>
